import Menu from '~/icons/menu.svg';
import { StyledSmallIconButton, StyledHeaderSmallIconOptionText } from '../styled';
import { useTranslation } from '~/shared/utils/translation';

export const MobileMegaMenuButton = () => {
    const { translate } = useTranslation();

    return (
        <StyledSmallIconButton
            href="/"
            onClick={(e) => {
                const html = document.documentElement;
                if (html.hasAttribute('data-menu-open')) {
                    html.removeAttribute('data-menu-open');
                } else {
                    html.setAttribute('data-menu-open', '');
                }

                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <Menu />{' '}
            <StyledHeaderSmallIconOptionText>
                {translate('header.menu')}
            </StyledHeaderSmallIconOptionText>
        </StyledSmallIconButton>
    );
};
